module.exports = __webpack_public_path__ + "img/page_1_1.e223adb9.png";